import { FC } from 'react';
import { Button } from '..';
import { ButtonProps, getParentSx } from '../containedButton';
import { SxProps, Theme } from '@mui/material';

export const OutlinedButton: FC<ButtonProps> = ({ text, small, ...buttonProps }) => {
  const color =
    buttonProps.color && buttonProps.color !== 'inherit' ? buttonProps.color : undefined;

  return (
    <Button
      {...buttonProps}
      small={small}
      variant="outlined"
      disableElevation
      sx={(theme) => ({
        fontWeight: 500,
        borderColor: color && theme.palette[color].main,
        borderWidth: '1.5px',
        '&:hover': {
          backgroundColor: 'unset',
          color: color && theme.palette[color].dark,
          borderColor: color && theme.palette[color].dark
        },
        '&.Mui-disabled': {
          color: color && !['neutral', 'primary'].includes(color) && theme.palette[color].light,
          borderColor:
            color && !['neutral', 'primary'].includes(color) && theme.palette[color].light
        },
        ...getParentSx(buttonProps.sx as SxProps<Theme> & undefined, theme)
      })}
    >
      {text}
    </Button>
  );
};
